import React from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './main.css';

import person from './images/Section 2  - Person.svg';

function Section2() {
    AOS.init();
    return (
        <section className="australia-council-section2-container">
            <div className="ac-section2-paragraph">
                <h2 data-aos="fade-down" data-aos-delay="50" data-aos-duration="2000" data-aos-once="true">
                    We know that Australia & New Zealand
                    are in the Midst of an Unprecedented
                Digital Transformation Era. </h2>

                <h4 data-aos="fade-down" data-aos-delay="100" data-aos-duration="1500" data-aos-once="true" style={{ marginTop: '10%' }}>Common challenges often encountered by  </h4>
                <h4 data-aos="fade-down" data-aos-delay="150" data-aos-duration="1500" data-aos-once="true" >Councils over the past 18 months have included:</h4>
            </div>

            <div className="ac-section2-image">
                <img src={person} height="510px" alt="" className="ac-section2-image-person" />
            </div>
        </section>

    )
}

export default Section2
